import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "children", "motionProps", "containerProps"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useDrawerContext } from "./chunk-VRAQ7LO3.mjs";
import { ModalFocusScope } from "./chunk-CJQLKBLU.mjs";
import { useModalContext, useModalStyles } from "./chunk-UUGUEMMH.mjs";

// src/drawer-content.tsx
import { cx } from "@chakra-ui/shared-utils";
import { chakra, forwardRef } from "@chakra-ui/system";
import { Slide } from "@chakra-ui/transition";
import { jsx } from "react/jsx-runtime";
var MotionDiv = chakra(Slide);
var DrawerContent = forwardRef(function (props, ref) {
  var className = props.className,
    children = props.children,
    motionProps = props.motionProps,
    rootProps = props.containerProps,
    rest = _objectWithoutProperties(props, _excluded);
  var _useModalContext = useModalContext(),
    getDialogProps = _useModalContext.getDialogProps,
    getDialogContainerProps = _useModalContext.getDialogContainerProps,
    isOpen = _useModalContext.isOpen;
  var dialogProps = getDialogProps(rest, ref);
  var containerProps = getDialogContainerProps(rootProps);
  var _className = cx("chakra-modal__content", className);
  var styles = useModalStyles();
  var dialogStyles = _objectSpread({
    display: "flex",
    flexDirection: "column",
    position: "relative",
    width: "100%",
    outline: 0
  }, styles.dialog);
  var dialogContainerStyles = _objectSpread({
    display: "flex",
    width: "100vw",
    height: "$100vh",
    position: "fixed",
    left: 0,
    top: 0
  }, styles.dialogContainer);
  var _useDrawerContext = useDrawerContext(),
    placement = _useDrawerContext.placement;
  return /* @__PURE__ */jsx(ModalFocusScope, {
    children: /* @__PURE__ */jsx(chakra.div, _objectSpread(_objectSpread({}, containerProps), {}, {
      className: "chakra-modal__content-container",
      __css: dialogContainerStyles,
      children: /* @__PURE__ */jsx(MotionDiv, _objectSpread(_objectSpread({
        motionProps: motionProps,
        direction: placement,
        in: isOpen,
        className: _className
      }, dialogProps), {}, {
        __css: dialogStyles,
        children: children
      }))
    }))
  });
});
DrawerContent.displayName = "DrawerContent";
export { DrawerContent };